import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

import {
  NetworkInnerWrapper,
  NetworkWrapper,
  ResponsiveText,
} from '../DataCard.style';
import { NetWorkStatus } from '../NetWorkStatus';
import { PlanIndicator } from '../PlanIndicator';

type Props = {
  isNetworkInfo: boolean;
  enableMapViewHideOption: boolean;
  color: string;
  expandedProviderListView: boolean;
  isGroupedLocationDrawer: boolean;
  isNewMapViewDataCardDesign: boolean;
  providerId: string;
  sectionTypeDerived: string;
  networkStatus: string;
  networkStatusWithPlanName?: string;
  planList: string[] | undefined;
  isGEHAV2: boolean;
};

export const NetworkDisplay = ({
  enableMapViewHideOption,
  isNetworkInfo,
  expandedProviderListView,
  isGroupedLocationDrawer,
  isNewMapViewDataCardDesign,
  providerId,
  sectionTypeDerived,
  networkStatus,
  networkStatusWithPlanName,
  color,
  planList,
  isGEHAV2,
}: Props) => (
  <>
    {enableMapViewHideOption ? (
      <NetworkWrapper
        cssProps={{ enableMapViewHideOption, expandedProviderListView }}
        data-testid="in-network-badge-container"
      >
        <NetworkInnerWrapper>
          {planList && planList?.length >= 1 ? (
            planList?.map((planName: string) => (
              <>
                <NetWorkStatus
                  color={color}
                  cssProps={{
                    isGroupedLocationDrawer,
                    enableMapViewHideOption,
                    isNewMapViewDataCardDesign,
                  }}
                  enableMapViewHideOption={enableMapViewHideOption}
                  expandedProviderListView={expandedProviderListView}
                  isGEHAV2={isGEHAV2}
                  isGroupedLocationDrawer={isGroupedLocationDrawer}
                  key={planName}
                  networkStatus={networkStatusWithPlanName ?? ''}
                  providerId={providerId}
                  sectionTypeDerived={sectionTypeDerived}
                />
                <PlanIndicator
                  cssProps={{
                    isGroupedLocationDrawer,
                    enableMapViewHideOption,
                    isNewMapViewDataCardDesign,
                    isWrapText: true,
                  }}
                  data-auto-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
                  data-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
                  enableMapViewHideOption={enableMapViewHideOption}
                  isNetworkInfo={isNetworkInfo}
                  planName={planName}
                />
              </>
            ))
          ) : (
            <NetWorkStatus
              color={color}
              cssProps={{
                isGroupedLocationDrawer,
                enableMapViewHideOption,
                isNewMapViewDataCardDesign,
              }}
              enableMapViewHideOption={enableMapViewHideOption}
              expandedProviderListView={expandedProviderListView}
              isGEHAV2={isGEHAV2}
              isGroupedLocationDrawer={isGroupedLocationDrawer}
              networkStatus={networkStatus ?? ''}
              providerId={providerId}
              sectionTypeDerived={sectionTypeDerived}
            />
          )}
        </NetworkInnerWrapper>
      </NetworkWrapper>
    ) : (
      <>
        {planList && planList.length >= 1 ? (
          planList.map((planName: string) => (
            <NetworkWrapper
              cssProps={{ enableMapViewHideOption }}
              data-testid={`data-card-network-${sectionTypeDerived}-section`}
              key={planName}
            >
              <IconSymbol
                color={color}
                css={{
                  '@media (max-width: 464px)': {
                    marginLeft: '12px',
                  },
                }}
                data-auto-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
                data-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
                icon="check_circle"
                size={16}
              />
              <ResponsiveText
                cssProps={{
                  isGroupedLocationDrawer,
                  enableMapViewHideOption,
                }}
                data-auto-testid={`data-card-network-${sectionTypeDerived}-${providerId}`}
                data-testid={`data-card-network-${sectionTypeDerived}-${providerId}`}
                fontWeight={enableMapViewHideOption ? 'regular' : 'medium'}
              >
                {networkStatusWithPlanName}
              </ResponsiveText>
              <PlanIndicator
                cssProps={{
                  isGroupedLocationDrawer,
                  enableMapViewHideOption,
                }}
                data-auto-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
                data-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
                enableMapViewHideOption={enableMapViewHideOption}
                isNetworkInfo={isNetworkInfo}
                planName={planName}
              />
            </NetworkWrapper>
          ))
        ) : (
          <NetworkWrapper
            cssProps={{ enableMapViewHideOption }}
            data-testid={`data-card-network-${sectionTypeDerived}-section`}
          >
            <IconSymbol
              color={color}
              data-auto-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
              data-testid={`data-card-plan-name-${sectionTypeDerived}-${providerId}`}
              icon="check_circle"
              size={16}
            />
            <ResponsiveText
              cssProps={{
                isGroupedLocationDrawer,
                enableMapViewHideOption,
              }}
              data-auto-testid={`data-card-network-${sectionTypeDerived}-${providerId}`}
              data-testid={`data-card-network-${sectionTypeDerived}-${providerId}`}
              fontWeight={enableMapViewHideOption ? 'regular' : 'medium'}
            >
              {networkStatus}
            </ResponsiveText>
          </NetworkWrapper>
        )}
      </>
    )}
  </>
);
